import React from 'react';
import { faBuilding } from '@fortawesome/pro-light-svg-icons/faBuilding';
import { faCalendar } from '@fortawesome/pro-light-svg-icons/faCalendar';
import { faCalendarPlus } from '@fortawesome/pro-light-svg-icons/faCalendarPlus';
import { faCog } from '@fortawesome/pro-light-svg-icons/faCog';
import { faFileExcel } from '@fortawesome/pro-light-svg-icons/faFileExcel';
import { faFolders } from '@fortawesome/pro-light-svg-icons/faFolders';
import { faHandPointLeft } from '@fortawesome/pro-light-svg-icons/faHandPointLeft';
import { faKey } from '@fortawesome/pro-light-svg-icons/faKey';
import { faPercent } from '@fortawesome/pro-light-svg-icons/faPercent';
import { faPoundSign } from '@fortawesome/pro-light-svg-icons/faPoundSign';
import { faShoppingBasket } from '@fortawesome/pro-light-svg-icons/faShoppingBasket';
import { faStickyNote } from '@fortawesome/pro-light-svg-icons/faStickyNote';
import { faThLarge } from '@fortawesome/pro-light-svg-icons/faThLarge';
import { faTreePalm } from '@fortawesome/pro-light-svg-icons/faTreePalm';
import { faUserClock } from '@fortawesome/pro-light-svg-icons/faUserClock';
import { faWatch } from '@fortawesome/pro-light-svg-icons/faWatch';
import { faWrench } from '@fortawesome/pro-solid-svg-icons/faWrench';
import { faDraftingCompass } from "@fortawesome/pro-regular-svg-icons/faDraftingCompass";
import { faTrash } from "@fortawesome/pro-solid-svg-icons/faTrash";
import { faWarehouse } from "@fortawesome/pro-solid-svg-icons/faWarehouse";
import { faPeopleArrows } from "@fortawesome/pro-solid-svg-icons/faPeopleArrows";
import { faCogs } from "@fortawesome/pro-light-svg-icons/faCogs";

import NavLink from 'Components/Partials/Layouts/NavLink';
import SideNavDropdown from 'Components/Partials/Layouts/SideNavDropdown';

import { Scopes } from 'Services';

const SideNavItems = ({type, holidayApprovals, accidentLog, overtimeApprovals, suspendedStockPending}) => (
    <React.Fragment>
        {type === 'admin' && (
            <nav className="flex-1">
                <NavLink
                    to="/"
                    disableActive={true}
                    label="Back"
                    icon={faHandPointLeft}
                />

                {Scopes.has('groups.*') && (
                    <NavLink
                        icon={faKey}
                        label="Groups"
                        to="/admin/groups"
                    />
                )}

                {Scopes.has('departments.*') && (
                    <NavLink
                        icon={faBuilding}
                        label="Departments"
                        to="/admin/departments"
                    />
                )}

                {Scopes.has('services.*') && (
                    <NavLink
                        label="Services"
                        to="/admin/services"
                        icon={faWrench}
                    />
                )}

                {Scopes.has('project-types.*') && (
                    <NavLink
                        label="Job Types"
                        to="/admin/projects/types"
                        icon={faThLarge}
                    />
                )}

                {Scopes.has('taxes.*') && (
                    <NavLink
                        label="Tax Rates"
                        to="/admin/tax-rates"
                        icon={faPercent}
                    />
                )}

                {Scopes.has('working-pattern.*') && (
                    <NavLink
                        label="Working Patterns"
                        to="/admin/working-patterns"
                        icon={faUserClock}
                    />
                )}

                {Scopes.has('company-holidays.*') && (
                    <NavLink
                        label="Company Holidays"
                        to="/admin/company-holidays"
                        icon={faTreePalm}
                    />
                )}

                {Scopes.has('deleted-items.*') && (
                    <NavLink
                        label="Deleted Items"
                        to="/admin/deleted-items"
                        icon={faTrash}
                    />
                )}

                {Scopes.has('job-spec.manage') && (
                    <NavLink
                        to="/admin/job-spec"
                        label='Job Spec'
                        icon={faStickyNote}
                    />
                )}

                {Scopes.has('options.*') && (
                    <NavLink
                        to="/admin/options"
                        label='Options'
                        icon={faCogs}
                    />
                )}
            </nav>
        )}

        {type === 'normal' && (
            <nav className="flex-1">
                {Scopes.has("dashboard.*") && (
                    <NavLink
                        to="/dashboard"
                        label='Dashboard'
                        icon={faCog}
                    />
                )}

                {Scopes.has('noticeboard.*') && (
                    <NavLink
                        icon={faStickyNote}
                        label="Noticeboard"
                        to="/noticeboard"
                    />
                )}

                {Scopes.has('diary.*') && (
                    <NavLink
                        icon={faCalendar}
                        label="Diary"
                        to="/diary"
                    />
                )}

                {Scopes.has('workshop-diary.*') && (
                    <NavLink
                        icon={faCalendar}
                        label="Workshop Diary"
                        to="/workshop-diary"
                    />
                )}

                {Scopes.has('time.*') && (
                    <NavLink
                        icon={faWatch}
                        label="Time Entry"
                        to="/time"
                    />
                )}

                <SideNavDropdown
                    label="Admin"
                    icon={faCogs}
                    items={[
                        {
                            scope: 'attendances.view',
                            label: "Attendances",
                            to: "/attendances"
                        },
                        {
                            scope: 'guests.*',
                            label: "Guests",
                            to: "/guests",
                        },
                        {
                            scope: 'meeting-room.manage',
                            label: "Meeting Rooms",
                            to: "/meeting-rooms"
                        },
                        {
                            scope: 'users.*',
                            label: "Staff",
                            to: "/staff"
                        },
                        {
                            scope: ['holiday.review', 'holiday.manage-department'],
                            label: "Holiday Approvals",
                            to: "/holidays",
                            notification: holidayApprovals > 0,
                        },
                        {
                            scope: 'overtime.manage',
                            label: "Overtime Approvals",
                            to: "/overtime-approvals",
                            notification: overtimeApprovals > 0,
                        },
                        {
                            scope: 'how-tos.*',
                            label: "How Tos",
                            to: "/documents/how-to",
                        },
                        {
                            scope: 'logs.*',
                            label: "Logs",
                            to: "/logs",
                        }
                    ]}
                />

                <SideNavDropdown
                    label="Events"
                    icon={faCalendarPlus}
                    items={[
                        {
                            scope: 'events.*',
                            label: "Events List",
                            to: '/events',
                        },
                        {
                            scope: 'schedules.*',
                            label: 'Schedules',
                            to: '/schedules',
                        },
                        {
                            scope: 'below-zero.*',
                            label: "Below Zero Diary",
                            to: '/below-zero/diary',
                        }
                    ]}
                />

                <SideNavDropdown
                    label="Projects"
                    icon={faFolders}
                    items={[
                        {
                            scope: 'customers.*',
                            label: "Customers",
                            to: '/customers',
                        },
                        {
                            scope: 'proposals.*',
                            label: "Estimates",
                            to: "/estimates"
                        },
                        {
                            scope: 'projects.*',
                            label: "Jobs",
                            to: "/jobs/list"
                        },
                        {
                            scope: 'projects.*',
                            label: "All Jobs Dashboard",
                            to: "/jobs/dashboard"
                        },
                        {
                            scope: 'projects.*',
                            label: "New Car Dashboard",
                            to: "/jobs/dashboard/new-car"
                        },
                        {
                            scope: 'projects.*',
                            label: "Current Projects",
                            to: "/jobs/current-projects"
                        },
                        {
                            scope: 'vehicles.*',
                            label: "Vehicles",
                            to: "/vehicles"
                        },
                        {
                            scope: 'scheduling.*',
                            label: "Scheduling",
                            to: "/scheduling"
                        }
                    ]}
                />

                <SideNavDropdown
                    label="Stock"
                    icon={faShoppingBasket}
                    items={[
                        {
                            scope: 'suppliers.*',
                            label: "Suppliers",
                            to: '/suppliers',
                        },
                        {
                            scope: 'parts.*',
                            label: "Parts",
                            to: "/inventory/parts"
                        },
                        {
                            scope: 'holding-orders.*',
                            label: "Holding Orders",
                            to: "/inventory/holding-orders"
                        },
                        {
                            scope: 'purchase-orders.*',
                            label: "Purchase Orders",
                            to: "/inventory/purchase-orders"
                        },
                        {
                            scope: 'suspended-stock.*',
                            label: "Suspended Stock",
                            to: "/inventory/suspended-stock",
                            notification: suspendedStockPending > 0
                        },
                        {
                            scope: 'parts-picker.*',
                            label: "Parts Picker",
                            to: "/parts-picker"
                        },
                        {
                            scope: 'stock-locations.*',
                            label: "Stock Locations",
                            to: "/stock-locations"
                        }
                    ]}
                />

                <SideNavDropdown
                    label="Technical"
                    icon={faDraftingCompass}
                    items={[
                        {
                            scope: 'boms.*',
                            label: "BOM",
                            to: "/templates"
                        },
                        {
                            scope: 'technical-bulletins.*',
                            label: "Technical Bulletins",
                            to: "/documents/technical-bulletin"
                        },
                        {
                            scope: 'build-manuals.*',
                            label: "Build Manuals",
                            to: "/documents/build-manual",
                        },
                        {
                            scope: 'drawings.*',
                            label: "Drawings",
                            to: "/documents/drawing",
                        }
                    ]}
                />

                <SideNavDropdown
                    label="Finance"
                    icon={faPoundSign}
                    items={[
                        {
                            scope: 'customers.*',
                            label: "Customers",
                            to: '/customers',
                        },
                        {
                            scope: 'invoices.*',
                            label: "Invoices",
                            to: "/invoices"
                        },
                        {
                            scope: 'credits.*',
                            label: "Credits",
                            to: "/credits"
                        },
                        {
                            scope: 'projects.*',
                            label: "Jobs",
                            to: "/jobs/list"
                        },
                        {
                            scope: 'transactions.view',
                            label: 'Customer Transactions',
                            to: '/transactions'
                        },
                        {
                            scope: 'suppliers.*',
                            label: "Suppliers",
                            to: '/suppliers',
                        },
                        {
                            scope: 'purchase-orders.*',
                            label: "Purchase Orders",
                            to: "/inventory/purchase-orders"
                        },
                    ]}
                />

                <SideNavDropdown
                    label="Reporting"
                    icon={faFileExcel}
                    items={[
                        {
                            scope: 'reports.*',
                            label: "Reports Builder",
                            to: '/reports',
                        },
                        {
                            scope: 'reports.*',
                            label: "Custom Reports",
                            to: "/reports/custom"
                        },
                    ]}
                />

                <SideNavDropdown
                    label="HR/H&S"
                    icon={faPeopleArrows}
                    items={[
                        {
                            scope: 'org-charts.*',
                            label: "Organisation Charts",
                            to: '/org-charts',
                        },
                        {
                            scope: 'handbook.*',
                            label: "Staff Handbook",
                            to: "/handbook"
                        },
                        {
                            scope: 'data-sheets.*',
                            label: 'H&S Data Sheets',
                            to: '/documents/data-sheet'
                        },
                        {
                            scope: 'health-and-safety-documents.*',
                            label: 'H&S Documents',
                            to: '/documents/health-and-safety-document'
                        },
                        {
                            scope: 'accident-log.*',
                            label: 'Accident Log',
                            to: '/accident-log',
                            notification: accidentLog > 0
                        }
                    ]}
                />
            </nav>
        )}
    </React.Fragment>
);

export default SideNavItems;
